import dayjs from 'dayjs'

// The alert feed is shared across Red Funnel's applications; only booking alerts
// concern this app.
export const BOOKING_APPLICATION = 'booking'

// An alert only puts the booking app into maintenance mode if it links to the
// maintenance page - that link is the trigger, not the alert type or the wording.
export const MAINTENANCE_PATH = '/maintenance'

export const isBookingAlert = alert =>
  !!alert?.application?.includes(BOOKING_APPLICATION)

export const isMaintenanceAlert = alert =>
  typeof alert?.link?.url === 'string' &&
  alert.link.url.includes(MAINTENANCE_PATH)

/**
 * Alerts carry their own schedule, and the feed is not trusted to have applied it
 * - an alert outside its window must not take the site down.
 */
export const isAlertScheduled = (alert, now = dayjs()) => {
  const { start, end } = alert?.schedule || {}
  if (start && dayjs(start).isValid() && now.isBefore(dayjs(start)))
    return false
  if (end && dayjs(end).isValid() && now.isAfter(dayjs(end))) return false
  return true
}

/**
 * The alert that should replace the booking app with the maintenance page, or
 * null when booking should carry on as normal.
 */
export const findMaintenanceAlert = (siteAlerts, now = dayjs()) =>
  (Array.isArray(siteAlerts) ? siteAlerts : []).find(
    alert =>
      isBookingAlert(alert) &&
      isMaintenanceAlert(alert) &&
      isAlertScheduled(alert, now),
  ) || null

// Titles are written for an inline banner, where the message runs on from the
// title ("Upcoming site maintenance - on 03/06/25 ..."). As a heading that
// trailing punctuation reads as though the sentence was cut off.
export const formatAlertTitle = title =>
  (title || '')
    .trim()
    .replace(/[-–—:]\s*$/, '')
    .trim()
